module.exports = __webpack_public_path__ + "img/roche-small.1894a75c.png";